module.exports = "/_next/static/images/24-1-d0090e57873e8293f9a8bf82f6548fbd.svg";